export const NetworkContextName = 'NETWORK';


const chainIdToIcon = {
    1: "ethereum-icon.png",   // Ethereum Mainnet
    56: "bsc-icon.png",        // Binance Smart Chain Mainnet
    97: "bsc-testnet-icon.png", // Binance Smart Chain Testnet
    // Add more mappings for other networks if needed
  };